var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable react/prop-types */
import { useEffect, useRef, useState } from "react";
import { getBrokerageCalculation, } from "src/apis/dashboard";
import Backfill from "src/components/backfill/backfill";
import Loader from "src/components/loader/loader";
import { COMMODITY_SEGMENT } from "src/utils/constant";
import { getDefaultDateFormat, getDisplayTextFromExchange, getExhangeTypeColor, getSegmentAndProductType, intComma, splitAndGetDetailsFromLongName, } from "src/utils/methods";
import { getDataFromSession } from "src/utils/session-storage";
import { ToastUtils } from "src/utils/toast-utils";
import styles from "./buyform.module.scss";
import { SESSION_KEYS } from "../../../../utils/session-storage";
import Modal from "react-modal";
import { v4 as uuid } from "uuid";
import Shimmer from "src/components/loader/shimmer";
const { REACT_APP_ENV } = process.env;
const ChargesModal = ({ 
//toggleChargesModal,
mode, quantity, buyPrice, sellPrice, scripCode, exch, exchType, location, name, stockQuantity, lotSize, formType, isLoadingBuyForm, }) => {
    const [charges, setCharges] = useState([]);
    const segmentTypeObj = getSegmentAndProductType(name, exch, exchType);
    const exchange = getDisplayTextFromExchange(exch, exchType, false);
    const [isLoading, setLoading] = useState(true);
    const [chargesModal, setChargesModal] = useState(false);
    const [totalCharges, setTotalCharges] = useState(0);
    const [showShimmer, setShowShimmer] = useState(false);
    const qty = useRef(0);
    const scripCodeRef = useRef(0);
    const buyPriceRef = useRef(0);
    const sellPriceRef = useRef(0);
    const searchUIDRef = useRef(uuid());
    useEffect(() => {
        if (qty.current !== quantity && quantity > 0 && lotSize > 0) {
            //getBrokergeChargesCallback();
        }
        qty.current = quantity;
    }, [buyPrice, sellPrice, stockQuantity, qty, scripCode, lotSize]);
    useEffect(() => {
        // if (quantity) {
        //qty.current = qty;
        if (scripCode !== scripCodeRef.current && quantity > 0) {
            //getBrokergeChargesCallback();
        }
        //  console.log(buyPriceRef.current, sellPriceRef.current, " CURENT REF");
        if (buyPriceRef.current == 0 && quantity > 0 && formType == "BUY") {
            //getBrokergeChargesCallback();
        }
        if (sellPriceRef.current == 0 && quantity > 0 && formType == "SELL") {
            //getBrokergeChargesCallback();
        }
        scripCodeRef.current = scripCode;
        buyPriceRef.current = buyPrice;
        sellPriceRef.current = sellPrice;
        // }
    }, [buyPrice, sellPrice, scripCode]);
    let tempExchangeTxt;
    if (exchange == "NFO") {
        tempExchangeTxt = "NSE";
    }
    else if (exchange == "BFO") {
        tempExchangeTxt = "BSE";
    }
    else if (exchange == "CURR") {
        tempExchangeTxt = "NSE";
    }
    else {
        tempExchangeTxt = exchange;
    }
    const getBrokergeChargesCallback = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        try {
            let planId = getDataFromSession(SESSION_KEYS.PLAN_ID);
            // let planId = "Ultra";
            if (!planId) {
                planId = "basic";
            }
            if (planId) {
                const dataObj = {
                    segment: segmentTypeObj.segmentType,
                    product: segmentTypeObj.productType,
                    mode: mode,
                    quantity: quantity,
                    buyPrice: buyPrice,
                    sellPrice: sellPrice,
                    plan: planId,
                    scripCode: scripCode,
                    exchange: exchange,
                };
                // const responseTemp = await getBrokerageCalculationImpl(
                //   dataObj,
                //   searchUIDRef.current
                // );
                // console.log(responseTemp, "____> ABORT RES");
                //console.log(quantity, stockQuantity, lotSize, "---");
                //const scriptQty = quantity && isFinite(quantity) ? quantity : 1;
                //console.log(scriptQty, "===>");
                const scriptQty = quantity;
                const response = yield getBrokerageCalculation(dataObj
                // segmentTypeObj.segmentType,
                // segmentTypeObj.productType,
                // mode,
                // scriptQty,
                // buyPrice,
                // sellPrice,
                // planId,
                // scripCode,
                // tempExchangeTxt
                );
                //
                const localCharges = [];
                //console.log(response, "--->");
                if (response.data.StatusCode == 200) {
                    const dataObj = response.data.data[0];
                    localCharges.push({
                        dataLabel: "Turnover",
                        dataValue: dataObj.Turnover,
                    });
                    localCharges.push({
                        dataLabel: "Brokerage",
                        dataValue: dataObj.Brokerage,
                    });
                    if (segmentTypeObj.segmentType == COMMODITY_SEGMENT) {
                        localCharges.push({
                            dataLabel: "CTT",
                            dataValue: dataObj.CTT,
                        });
                    }
                    else {
                        localCharges.push({
                            dataLabel: "STT",
                            dataValue: dataObj.STT,
                        });
                    }
                    localCharges.push({
                        dataLabel: "Exchange Trnx Charge",
                        dataValue: dataObj.ExhangeTrnxCharge,
                    });
                    localCharges.push({
                        dataLabel: "Clearing Charges",
                        dataValue: dataObj.ClearingCharges,
                    });
                    localCharges.push({
                        dataLabel: "Stamp Duty",
                        dataValue: dataObj.StampDuty,
                    });
                    localCharges.push({
                        dataLabel: "GST",
                        dataValue: dataObj.GST,
                    });
                    localCharges.push({
                        dataLabel: "SEBI Charges",
                        dataValue: dataObj.SEBICharges,
                    });
                    localCharges.push({
                        dataLabel: "Total Charges",
                        dataValue: dataObj.TotalCharges,
                    });
                    setTotalCharges(dataObj.TotalCharges);
                    setCharges(localCharges);
                    setShowShimmer(false);
                }
                else {
                    ToastUtils.error(response.data.StatusMessage);
                }
            }
        }
        catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false);
        }
    });
    useEffect(() => {
        //console.log("CHARGES INIt");
        setShowShimmer(false);
    }, []);
    const toggleChargesModal = () => {
        setChargesModal((chargesModal) => !chargesModal);
        //getBrokergeChargesCallback();
    };
    const nameBreakup = splitAndGetDetailsFromLongName(name);
    const scriptTypeColor = getExhangeTypeColor(nameBreakup.scripType);
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: `${styles.marginText} pointer` }, { children: [_jsxs("p", { children: ["Charges", chargesModal, " "] }), _jsx("div", Object.assign({ className: "d-flex" }, { children: showShimmer || isLoadingBuyForm || lotSize == 0 ? (_jsx(Shimmer, {})) : (_jsx("span", Object.assign({ className: `${styles.chargesBtn}` }, { children: "\u20B9 0" }))) }))] })), _jsx(Modal, Object.assign({ isOpen: chargesModal, onRequestClose: toggleChargesModal, className: `${styles.myCommonModal} ${styles.chargesModalWrapper}`, overlayClassName: styles.myCommonOverlay }, { children: _jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: styles.modalHeaderPart }, { children: [_jsx("h6", Object.assign({ className: "mb-0 large mediumWeight" }, { children: "Transaction Charges" })), _jsx("span", { className: "closeIcon", onClick: toggleChargesModal })] })), _jsxs("div", Object.assign({ className: `${styles.modalBodyPart}` }, { children: [_jsxs("div", Object.assign({ className: `${styles.scripTopRow}` }, { children: [nameBreakup.name, _jsx("span", Object.assign({ className: "ms-1" }, { children: getDefaultDateFormat(nameBreakup.expiry) })), _jsx("span", Object.assign({ className: scriptTypeColor + ` ms-1` }, { children: nameBreakup.scripType })), _jsx("span", Object.assign({ className: "ms-1" }, { children: nameBreakup.strikeRate })), _jsx("span", Object.assign({ className: "greyBgTag small ms-2 px-1" }, { children: getDisplayTextFromExchange(exch, exchType, false) })), _jsx("span", Object.assign({ className: "greyBgTag ms-2 px-1" }, { children: mode == "delivery" ? "DEL" : "INT" })), _jsx("span", Object.assign({ className: (sellPrice == 0 ? "buyBgTag" : "sellBgTag") + " ms-2 px-1" }, { children: sellPrice == 0 ? "BUY" : "SELL" }))] })), _jsx("ul", Object.assign({ className: `${styles.keyDataList} pb-3` }, { children: isLoading ? (_jsx(Loader, {})) : charges.length > 0 ? (charges.map((item, index) => {
                                        return (_jsxs("li", { children: [_jsx("span", { children: item.dataLabel }), _jsxs("span", { children: ["\u20B9 ", intComma(item.dataValue, 2, 2)] })] }, index));
                                    })) : (_jsx("div", Object.assign({ className: "mb-4" }, { children: _jsx(Backfill, { errorMessage: "No data found." }) }))) }))] }))] }) }))] }));
};
export default ChargesModal;
